<template>
  <div class="out-storage-scan">
    <div class="tab-content">
      <div class="scanner-card">
        <div class="card-header">
          <span class="header-emoji">📟</span>
          <h3>扫码枪快速录入 - 盘库计划：{{ gunSelectedTaskName }}</h3>
        </div>
        <el-select v-if="!diaflag"
            v-model="gunTaskId"
            placeholder="请选择盘库计划"
            style="margin-bottom: 20px; width: 300px;"
            @change="gunOnTaskChange"
        >
          <el-option
              v-for="item in cktaskList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          />
        </el-select>

        <el-row :gutter="20">
          <el-col :span="!diaflag?14:24">
            <div class="left-panel">
              <h4 class="panel-title">设备庆清点进度</h4>
              <el-table
                  :data="gunDeviceList"
                  border
                  stripe
                  style="width: 100%"
                  height="480"
              >
                <el-table-column prop="name" label="设备" min-width="180" show-overflow-tooltip>

                </el-table-column>
                <el-table-column prop="num" label="应有" width="120" align="center" v-if="!diaflag"/>
                <el-table-column prop="yz" label="已查" width="120" align="center">
                  <template slot-scope="scope">
                        <span :class="{ 'out-highlight': scope.row.num >= scope.row.yz }">
                          {{ scope.row.yz || 0 }}
                        </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>

          <el-col :span="10" v-if="!diaflag">
            <div class="right-panel">
              <h4 class="panel-title">扫码或手填后回车</h4>

              <el-input
                  v-model="scanCode"
                  ref="scanInput"
                  placeholder="对准条码扫描 → 自动处理"
                  clearable
                  autofocus
                  class="scan-input-large"
                  @keydown.enter.native="gunHandleScanEnter"
              />

              <div class="current-status" :class="gunStatus">
                    <span class="status-emoji">
                      <template v-if="gunStatus === 'loading'">⌛️</template>
                      <template v-else-if="gunStatus === 'success'">✅</template>
                      <template v-else-if="gunStatus === 'warning'">⚠️</template>
                      <template v-else-if="gunStatus === 'error'">❌</template>
                      <template v-else>⏳</template>
                    </span>
                <span class="status-text">{{ gunStatusText || '等待扫描...' }}</span>
              </div>

              <div class="guide-text">
                <p>扫码枪扫描后自动确认</p>
                <p>成功会更新左侧进度</p>
              </div>

              <el-button type="primary" plain @click="gunFocusInput" class="focus-btn">
                点击聚焦输入框
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    sid: {
      type: String,
      default: "",
    },
    sname: {
      type: String,
      default: "",
    },
    diaflag: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      // 公共：任务列表 + 商品列表（两个 tab 共用）
      cktaskList: [],
      productList: [],
      // 扫码枪 tab 数据（独立）
      gunTaskId: undefined,
      gunSelectedTaskName: '',
      gunDeviceList: [],
      scanCode: '',
      gunStatus: '',
      gunStatusText: '等待扫描...'
    }
  },

  mounted() {
    this.gettask()
    if (this.sid != null && this.sid != 0) {
      this.gunTaskId = this.sid
      this.gunGetDeviceList()
    }
    if (this.sname != null && this.sname != 0) {
      this.gunSelectedTaskName = this.sname
    }
    this.getproductList()
    // 扫码枪初始聚焦（可选）
    this.$nextTick(() => {
      this.gunFocusInput()
    })
  },

  beforeDestroy() {
    this.phoneStopScanning()
  },

  methods: {

    // 公共方法
    gettask() {
      this.$request.postHttp({
        url: "/basic/getStockList",
        success: (data) => {
          this.cktaskList = data.data || []
        },
        error: (error) => {
          console.error("获取任务失败:", error)
        }
      })
    },

    getproductList() {
      this.$request.postHttp({
        url: "/basic/getsp",
        success: (data) => {
          this.productList = data.data || []
        },
        error: (error) => {
          console.error("获取商品列表失败:", error)
        }
      })
    },

    formatepid(pid) {
      const found = this.productList.find(item => item.id == pid)
      return found ? found.name : '--'
    },


    // 扫码枪相关方法
    gunOnTaskChange() {
      const task = this.cktaskList.find(t => t.id === this.gunTaskId)
      this.gunSelectedTaskName = task ? task.name : ''
      if (this.gunTaskId) this.gunGetDeviceList()
    },

    gunGetDeviceList() {
      this.$request.getHttp({
        url: "/basic/getpkinfo",
        params: {id: this.gunTaskId},
        success: (data) => {
          this.gunDeviceList = data.data || []
        },
        error: (err) => {
          console.error(err)
        }
      })
    },

    gunFocusInput() {
      this.$refs.scanInput?.focus()
    },

    gunHandleScanEnter() {
      const code = this.scanCode.trim()
      if (!code) return
      if (!this.gunTaskId) {
        this.gunStatus = 'warning'
        this.gunStatusText = '请先选择盘库计划'
        return
      }

      this.gunStatus = 'loading'
      this.gunStatusText = '处理中...'

      this.$request.postHttp({
        url: "/basic/pkStock",
        params: {id: this.gunTaskId, bm: code},
        success: (data) => {
          if (data.code == 200) {
            this.gunGetDeviceList()
            this.gunStatus = 'success'
            this.gunStatusText = '已处理，列表刷新'
          } else {
            this.gunStatus = 'error'
            this.gunStatusText = data.msg
          }

        },
        error: (err) => {
          console.error('扫码枪出库失败', err)
          this.gunGetDeviceList()
          this.gunStatus = 'error'
          this.gunStatusText = err.msg
        }
      })

      this.scanCode = ''
      this.$nextTick(() => this.gunFocusInput())
    },
  }
}
</script>

<style scoped>
.out-storage-scan {
  padding: 20px;
}

.tab-content {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
}

@keyframes scanHorizontal {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}


/* 扫码枪原有样式 */
.scanner-card {
  padding: 20px;
}

.card-header {
  text-align: center;
  margin-bottom: 20px;
}

.header-emoji {
  font-size: 36px;
  margin-right: 12px;
}

.panel-title {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.left-panel, .right-panel {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.scan-input-large {
  width: 100%;
  margin-bottom: 16px;
  font-size: 16px;
}

.current-status {
  text-align: center;
  padding: 20px 0;
  border-radius: 8px;
  margin: 16px 0;
  font-size: 18px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.current-status.success {
  background: #f0f9eb;
  color: #67c23a;
}

.current-status.warning {
  background: #fdf6ec;
  color: #e6a23c;
}

.current-status.error {
  background: #fef0f0;
  color: #f56c6c;
}

.current-status.loading {
  background: #e6f7ff;
  color: #409eff;
}

.status-emoji {
  font-size: 36px;
  margin-right: 12px;
}

.guide-text {
  color: #909399;
  font-size: 13px;
  text-align: center;
  margin: 16px 0;
}

.focus-btn {
  width: 100%;
}

.out-highlight {
  color: #37f41a;
  font-weight: bold;
}

.phone-tab {
  padding: 15px;
}

.tab-title {
  font-size: 18px;
  margin: 0 0 15px;
  text-align: center;
  color: #303133;
}

.task-select-area {
  margin-bottom: 20px;
  text-align: center;
}

.scanner-section {
  margin-bottom: 25px;
}

.scanner-wrapper {
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: 0 auto 15px;
  border: 2px solid #409eff;
  border-radius: 10px;
  overflow: hidden;
  background: #000;
}

.reader-container {
  width: 100%;
  aspect-ratio: 4 / 3; /* 手机端更竖一些 */
}

.controls {
  display: flex;
  gap: 10px;
  margin: 15px 0;
  justify-content: center;
  flex-wrap: wrap;
}

.status-box {
  text-align: center;
  padding: 12px;
  background: #e6f7ff;
  border-radius: 8px;
  color: #409eff;
  font-size: 15px;
  margin: 10px 0;
}

.device-section {
  margin-top: 20px;
}

.list-title {
  font-size: 16px;
  margin-bottom: 10px;
  color: #303133;
}

.no-task-tip {
  text-align: center;
  padding: 40px 20px;
  color: #909399;
  font-size: 15px;
  background: #f5f7fa;
  border-radius: 8px;
}

.out-highlight {
  color: #67c23a;
  font-weight: bold;
}

/* 手机端小屏适配 */
@media (max-width: 768px) {
  .controls {

  }

  .controls .el-button {
    width: 30%;
  }
}
</style>